import { render, staticRenderFns } from "./Wp_waimai.vue?vue&type=template&id=4c3fe8b8&scoped=true&"
import script from "./Wp_waimai.vue?vue&type=script&lang=js&"
export * from "./Wp_waimai.vue?vue&type=script&lang=js&"
import style0 from "./Wp_waimai.vue?vue&type=style&index=0&id=4c3fe8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3fe8b8",
  null
  
)

export default component.exports